<template>
  <Store :Shop="Shop" />
  <div class="container-fluid NavbarElement" ref="NavbarElement">
    <nav class="navbar">
      <a :href="'http://line.naver.jp/R/msg/text/?發現一家好吃的店，趕快來看看吧！%0D%0A' + Shop.Name + '%0D%0A' + Global.Domain + '/OrderUser/Shop/' + Shop.id">
        <img src="./../../assets/img/LINE.png" />
      </a>
      <div class="mx-auto">
        <a class="navbar-brand" @click="Store()">
          <span class="shopName">{{Shop.Name}}</span>
          <span class="arrow-down"><i class="fa-solid fa-chevron-down"></i></span>
        </a>
      </div>
      <div :class="[Attention == 0 ? 'NoAttention' : 'Attention']" v-if="User" @click="changeAttention()">
        <i class="fas fa-heart" ata-bs-toggle="popover" data-bs-title="Popover title" data-bs-content="And here's some amazing content. It's very engaging. Right?"></i>
      </div>
    </nav>
    <div class="productCategoryBar" v-show="loadShopStatus == 0">
      <div class="Nav">
        <div class="navItem" :class="{ active: navActive == index }" v-for="(productData, index) in productsData" :key="productData.Name">
          <a :id="'A' + index"  @click="scrollToSection('productCategory_' + productData.id)">
            {{productData?.Name}}
          </a>
        </div>
        <div class="activeBar" :style="{left: activeBarPlace + 'px', width: activeBarWidth + 'px' }"></div>
      </div>
    </div>
    <div class="activityBar" v-if="this.$parent.$data.activityContent" v-html="this.$parent.$data.activityContent">
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Global } from '@/Service/GlobalService'
import Store from '@/components/Shop/Store'

import { getUserAttention, changeUserAttention } from '@/Service/APIService'

export default {
  name: "Navbar",
  components: { Store },
  props: {
    productsData: Object,
    loadShopStatus: Number,
    navbarHeight: Number
  },
  data() {
    return {
      Global: Global,
      Shop: Global.Shop, // 店家資料
      User: Global.User, // 消費者資料
      navActive: 0, // 目前頁面滑到第幾個商品類別處
      activeBarWidth: 0,
      activeBarPlace: 0,
      Attention: 0, // 消費者是否關注店家
      attentionContent: "已關注" + Global.Shop.Name,  // 跳出關注訊息
      NavbarElementHeight: 0
    }
  },
  methods: {
    init: async function() {
      /* 取得 NavbarElement 高度 */
      this.$parent.$data.navbarHeight = this.$refs.NavbarElement.offsetHeight

      /* 活動 */
      this.setActivityContent()

      /* 取得消費者是否關注店家 */
      if (!Global.User) return false

      const params = { userId: Global.User.id, shopId: Global.Shop.id }

      const response = await getUserAttention(params)

      this.$data.Attention = response.data
    },
    setActivityContent: function() {
      if (this.$data.Shop.Activity == "關") return false
      let activityContent = "<span class=horn>📣</span><span> 在 "
      if (this.$data.Shop.timeBefore && this.$data.Shop.timeAfter) {
        activityContent += this.$data.Shop.timeBefore.substring(0, 5) + " 以前，或 "
        activityContent += this.$data.Shop.timeAfter.substring(0, 5) + " 以後，"
      } else if (this.$data.Shop.timeBefore) {
        activityContent += this.$data.Shop.timeBefore.substring(0, 5) + " 以前"
      } else if (this.$data.Shop.timeAfter) {
        activityContent += this.$data.Shop.timeAfter.substring(0, 5) + " 以後，"
      }
      activityContent += "滿 " + this.$data.Shop.activityPrice + " 元，</span><span class=wrap>"
      if (this.$data.Shop.payOff) {
        activityContent += "折 " + this.$data.Shop.payOff +  " 元！"
      } else if (this.$data.Shop.Discount) {
        let strDiscount = this.$data.Shop.Discount.toString()
        if (strDiscount.length == 2) {
          if (strDiscount.substring(1) == "0") strDiscount = strDiscount.substring(0, 1)
        }
        activityContent += "打 " + strDiscount +  " 折！"
      } else if (this.$data.Shop.Gift) {
        activityContent += "送" + this.$data.Shop.Gift +  "！</span>"
      }
      this.$parent.$data.activityContent = activityContent
    },
    /* 切換消費者對店家的關注 */
    changeAttention: async function() {
      if (!Global.User) return false

      this.$data.Attention = this.$data.Attention == '0' ? '1' : '0'

      const params = { userId: Global.User.id, shopId: Global.Shop.id, Attention: this.$data.Attention }

      await changeUserAttention(params)

      if (this.$data.Attention == 0) {
        Global.emitToastContent("已取消關注" + this.$data.Shop.Name)
      } else {
        Global.emitToastContent("已關注" + this.$data.Shop.Name)
      }
      
      this.init()
    },
    scrollToSection: function(sectionId) {
      const section = this.$parent.$refs.Products.$refs[sectionId];
      const NavbarElement = this.$refs.NavbarElement
      if (section) {
        const fixedElementHeight = NavbarElement ? NavbarElement.offsetHeight : 0; // 動態計算固定元素的高度
        console.log(fixedElementHeight)
        window.scrollTo({
          top: section[0].offsetTop - fixedElementHeight - 8, // 如果你抓取到的是一個數組，確保你訪問到數組中的第一個元素
          behavior: 'smooth'
        });
      } else {
        console.error(`Section with id ${sectionId} not found.`);
      }
    },
    /* 顯示店家資訊 */
    Store: function() {
      $('#StoreModal').modal('toggle')
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.container-fluid {
  position: fixed !important;
  margin: 0px;
  padding: 0px;
  z-index: 999;
  .navbar {
    padding: 0px 10px;
    min-height: 67px;
    height: 8vh;
    background-color: #5599FF;
    color: #FFFFFF;
    font-size: 20px;
    font-weight: 900;
    > a {
      > img {
        max-height: 35px;
      }
    }
    > .mx-auto {
      > .navbar-brand {
        display: flex;
        align-items: center;
        margin: 0px;
        padding: 8px 10px;
        color: #FFFFFF;
        background-color: #4488FF;
        border-radius: 64px;
        > .shopName {
          padding-left: 3px;
        }
        > .arrow-down {
          padding-left: 10px;
          font-size: 12px;
          line-height: 25px;
        }
      }
    }
    .NoAttention {
      padding-right: 5px;
      color: #FFFFFF;
    }
    .Attention {
      padding-right: 5px;
      color: #0000CC;
    }
  }
  .Nav {
    display: flex;
    min-height: 40px;
    height: 6vh;
    overflow: auto;
    white-space: nowrap;
    background-color: #87CEFAAA;
    transform: translate(0, 0);
    > .navItem {
      display: flex;
      margin: 0px 20px;
      text-decoration: none;
      position: relative;
      width: 100%;
      text-align: center;
      justify-content: center;
      align-items: center;
      transition: 0.2s all linear;
      cursor: pointer;
      list-style: none;
      font-size: 18px;
      font-weight: 900;
      color: #FFFFFF;
      text-shadow: 2px 2px 0 #000000;
    }
  }
  > .activityBar {
    display: flex;
    align-items: center; /* 垂直置中 */
    justify-content: center; /* 水平置中 (可選) */
    min-height: 57px;
    background-color: #99FFFFAA;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #5599FF;
    > .horn {
      font-size: 25px;
    }
    > .wrap {
      display: inline-block;
      white-space: normal; /* 允許自動換行 */
      word-wrap: break-word; /* 確保長單字也能換行 */
      overflow-wrap: break-word; /* 確保長單字也能換行 */
    }
  }
}
@media (min-width:600px) and (max-width:900px) { 
  .container-fluid {
    position: fixed;
    > .activityBar {
      display: flex;
      min-height: 50px;
      padding: 3px 0px;
      line-height: 4vh;
      min-height: 57px;
      justify-content: center;
      font-size: 18px;
      align-items: center;
    }
  }
}

@media screen and (max-width:600px) { 
  .container-fluid {
    position: fixed;
    > .activityBar {
      display: flex;
      min-height: 50px;
      padding: 3px 0px;
      line-height: 4vh;
      min-height: 57px;
      text-align: center;
      font-size: 18px;
      flex-wrap: wrap;
    }
  }
}
</style>